import { GetConsultationsEffects } from './get-consultations.effects';

export const PetEffects = [GetConsultationsEffects];
